module.exports = __webpack_public_path__ + "img/arrow-right.00666991.svg";